/* globals $ */
'use strict';

angular.module('mediacloudApp')
    .directive('mediacloudAppPager', function() {
        return {
            templateUrl: 'scripts/components/form/pager.html'
        };
    });
